<template>
  <div>
    <div>
      <el-row>
        <div class="left-justifying"><h3>{{pageTitle}}</h3></div>
        <div class="right-justifying">
          <el-button type="info" plain size="small" @click="toAdd" v-if="addBtnExisted && hasPermission('menu.review.crud')">
            <i class="fa fa-plus-circle"></i> 新建
          </el-button>
          <el-button type="info" plain size="small" @click="saveAdd" v-if="saveAddBtnExisted && hasPermission('menu.review.crud')">
            <i class="fa fa-save"></i> 保存
          </el-button>
          <el-button type="info" plain size="small" @click="toEdit" v-if="editBtnExisted && hasPermission('menu.review.crud')">
            <i class="fa fa-pencil"></i> 修改
          </el-button>
          <el-button type="info" plain size="small" @click="saveEdit" v-if="saveEditBtnExisted && hasPermission('menu.review.crud')">
            <i class="fa fa-save"></i> 保存
          </el-button>
          <el-button type="info" plain size="small" @click="cancelEdit" v-if="cancelEditBtnExisted && hasPermission('menu.review.crud')">
            <i class="fa fa-undo"></i> 取消
          </el-button>

          <el-button type="info" plain size="small" @click="toEditReport" v-if="editReportBtnExisted && hasPermission('menu.review.crud')" :disabled="!editable">
            <i class="fa fa-pencil"></i> 修改
          </el-button>
          <el-button type="info" plain size="small" @click="saveEditReport" v-if="saveEditReportBtnExisted && hasPermission('menu.review.crud')">
            <i class="fa fa-save"></i> 保存
          </el-button>
          <el-button type="info" plain size="small" @click="cancelEditReport" v-if="cancelEditReportBtnExisted && hasPermission('menu.review.crud')">
            <i class="fa fa-undo"></i> 取消
          </el-button>

          <el-button type="info" plain size="small" @click="remove" v-if="deleteBtnExisted && hasPermission('menu.review.crud')" :disabled="!deletable">
            <i class="fa fa-times"></i> 删除
          </el-button>

          <el-button type="info" plain size="small" @click="toExportReport" v-if="toExportReportExisted">
            <i class="fa fa-undo"></i> 导出报告
          </el-button>

          <WorkflowRequestBtn :visible="workflowBtnExisted"
                              :bussiness="workflowBusiness"
                              :bussinessId="detail.data.id"
                              :bussinessInfo="workflowBussinessInfo"
                              :disabled="workflowReopenBtnExisted"
                              v-if="hasPermission('menu.review.crud')"
                              @afterRequestWorkflowFunc="afterRequestWorkflowFunc"
          >
          </WorkflowRequestBtn>
          <WorkflowDialog ref="workflowDialog"
                          :bussiness="workflowBusiness"
                          :bussinessId="detail.data.id"
                          :workflowRequestInfo="workflowRequestInfo"
                          :dialogWorkflowVisible.sync="workflowDialogVisible"
                          :status-name="'athubStatus'"
                          @afterAuditWorkflowFunc="afterAuditWorkflowFunc">

          </WorkflowDialog>
        </div>
      </el-row>
    </div>
    <div class="panel">
      <div class="panel-body">
        <el-row>
          <div class="advanced-search-location">
            <el-checkbox v-model="list.search.currentOrder" v-show="athubDropDownSearchShown" style="margin-right: 10px;" @change="handleCurrentOrderChange">当前工单</el-checkbox>
            <AthubDropDownSearch v-model="list.search" model-path="list.search" @formDataSubmit="query" :formWidth="800" v-show="athubDropDownSearchShown" size="mini" collapseTags multiple>
              <el-form v-model="list.search" label-width="120px">
                <div v-show="false">
                  <el-col :span="12">
                    <el-form-item label="报告编号">
                      <el-input size="mini" v-model="list.search.like_code" placeholder="报告编号"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="数据中心">
                      <dictionary-select v-model="list.search.eq_roomId" :factory-name="'room'" :params="{type: 'AUTH_SITE'}" clearable filterable size="mini"></dictionary-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="报告名称">
                      <el-input size="mini" v-model="list.search.like_name" placeholder="请输入报告名称"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="故障等级">
                      <dictionary-select v-model="list.search.in_failureLevel" :factory-name="'domain'" :params="'RPLEVEL'" clearable multiple collapseTags size="mini"></dictionary-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="报告制作人">
                      <el-input size="mini" v-model="list.search.like_reporterName" placeholder="请输入报告制作人"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="状态">
                      <dictionary-select v-model="list.search.in_status" :factory-name="'domain'" :params="'RPSTATUS'" clearable multiple collapseTags size="mini"></dictionary-select>
                    </el-form-item>
                  </el-col>
                </div>
                <el-row type="flex" class="row-bg">
                  <el-col :span="14">
                    <el-form-item label="故障开始时间">
                      <el-date-picker
                              size="mini"
                              v-model="list.search.range_failureStartTime"
                              format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                              type="datetimerange"
                              placeholder="故障开始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" class="row-bg">
                  <el-col :span="14">
                    <el-form-item label="故障类型">
                      <dictionary-select v-model="list.search.eq_failureType" :factory-name="'domain'" :params="'ASSETTYPE'" clearable filterable size="mini"></dictionary-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </AthubDropDownSearch>

            <el-tag v-show="activeTabName !== 'list'" type="danger" size="mini" style="margin-top: 9px;">
              状态：<dictionary-text :factory-name="'domain'" :params="'RPSTATUS'" :value="detail.data.status"></dictionary-text>
            </el-tag>
          </div>

          <el-tabs v-model="activeTabName" :before-leave="beforeLeave">
            <el-tab-pane label="列表" name="list">
              <review-report-list ref="list" :search="list.search" @selected-change="setCurrentRowData" @show-detail="showDetail"></review-report-list>
            </el-tab-pane>
            <el-tab-pane label="详情" name="detail">
              <review-report-detail ref="detail" @switch-tab="switchTab" @switch-operation="switchOperation"
                                    @detail-change="setCurrentDetailData" :operation="operation" :data="detail.data"
                                    @workflow-history-loaded="workflowHistoryLoaded"
              ></review-report-detail>
            </el-tab-pane>
            <el-tab-pane label="报告" name="report" v-if="isSpecial">
              <special-report ref="report" @switch-tab="switchTab" @switch-operation="switchOperation" :operation="operation" :review-report-id="detail.data.id"></special-report>
            </el-tab-pane>
          </el-tabs>
        </el-row>
      </div>
    </div>

  </div>
</template>

<script type="text/javascript">
  import DictionarySelect from "@/components/common/DictionarySelect";
  import DictionaryText from "@/components/common/DictionaryText";
  import AthubDropDownSearch from '@/components/common/athub.dropdown.search'
  import WorkflowRequestBtn from '@/components/workflow/workflowRequestBtn'
  import WorkflowReopenBtn from '@/components/workflow/workflowReopenBtn'
  import WorkflowDialog from '@/components/workflow/workflowDialog'
  import ReviewReportTypeMixin from './mixins/review-report-type'
  import ReviewReportList from './list'
  import ReviewReportDetail from './detail'
  import SpecialReport from './special_report'
  import {merge} from '@/util/common'

  import {Dictionary, DICTIONARY_FACTORY_DOMAIN, dictionaryContainer} from '@/util/common/dictionary'

  import {REVIEW_SERVER, WorkOrderServer} from "@/api";

  import AthubCloudApi from '@/api/athubCloud'
  import ReviewServer from '@/api/review';
  import reviewReport from "@/api/review/review_report";

  function addParamsToUrl(url, params) {
    if (params === undefined || params === null) {
      return url;
    }
    var index = url.indexOf('?'), separator = '';
    if (index === - 1) {
      separator = '?';
    } else if (index === url.length - 1) {
      separator = '';
    } else {
      separator = '&';
    }
    for (var key in params) {
      if (params.hasOwnProperty(key) && params[key] !== undefined && params[key] !== null && String(params[key]).trim() !== '') {
        url += separator + key + '=' + params[key];
        separator = '&';
      }
    }
    return url;
  };

  export default {
    name: 'ReviewReportMain',
    componentName: 'ReviewReportMain',
    mixins: [ReviewReportTypeMixin],
    components: {
      DictionarySelect,
      DictionaryText,
      AthubDropDownSearch,
      WorkflowRequestBtn,
      WorkflowReopenBtn,
      WorkflowDialog,
      ReviewReportList,
      ReviewReportDetail,
      SpecialReport,
    },
    data(){
      return {
        currentRowData: {},
        activeTabName: 'list',
        statusText: '',
        operation: 'list',
        type: '',
        isSentWorkflow: false,
        params: {
          source: null,
          ids: null,
          type: null,
          id: null,
        },
        list: {
          search: {
            currentOrder: true,
            like_code: null,
            eq_roomId: null,
            in_roomId: [-1],
            like_name: null,
            eq_failureLevel: null,
            in_failureLevel: null,
            like_reporterName: null,
            eq_status: null,
            in_status: ['DRAFT', 'WAPPR'],

            range_failureStartTime: null,
            eq_failureType: null,
            eq_type: null,
            in_id: null,
          },
        },
        detail: {
          data: {
            status: 'DRAFT',
          },
        },
        operations: {},

        workflowDialogVisible: false,
        workflowRequestInfo: {},
      };
    },
    computed: {
      pageTitle() {
        return this.isSpecial ? '专项复盘报告' : '厂商故障报告';
      },
      addBtnExisted() {
        return this.activeTabName === 'list';
      },
      editBtnExisted() {
        return this.operation === 'detail.show';
      },
      saveAddBtnExisted() {
        return this.operation === 'detail.add';
      },
      saveEditBtnExisted() {
        return this.operation === 'detail.edit';
      },
      cancelEditBtnExisted() {
        return this.operation === 'detail.edit';
      },
      deleteBtnExisted() {
        return this.operation === 'detail.show';
      },
      editReportBtnExisted() {
        return this.operation === 'report.show';
      },
      saveEditReportBtnExisted() {
        return this.operation === 'report.edit';
      },
      cancelEditReportBtnExisted() {
        return this.operation === 'report.edit';
      },
      toExportReportExisted() {
        return this.isSpecial && (this.operation === 'detail.show' || this.operation === 'report.show');
      },
      workflowBusiness() {
        return this.isSpecial ? 'SPECIALPROCESS' : 'VENDORPROCESS';
      },
      workflowBtnExisted() {
        return this.operation === 'detail.show';
      },
      workflowReopenBtnExisted() {
        return this.operation === 'detail.show' && (this.detail.data['status'] === 'CLOSE' || this.detail.data['status'] === 'CANCEL');
      },
      workflowBussinessInfo() {
        let bussinessInfo = {};
        bussinessInfo.params = JSON.stringify({
          ROOMID: this.detail.data.roomId
        });
        return bussinessInfo;
      },
      athubDropDownSearchShown() {
        return this.activeTabName === 'list';
      },
      editable() {
        return this.detail.data['status'] === 'DRAFT';
      },
      deletable() {
        return this.detail.data['status'] === 'DRAFT' && !this.isSentWorkflow;
      },
    },
    methods: {
      init() {
        this.handleCurrentOrderChange(this.list.search.currentOrder);
        this.type = this.$route.params.type != null ? this.$route.params.type.toUpperCase() : null;
        this.list.search.eq_type = this.type;
        let tab = this.$route.query.tab;
        if (tab === 'detail') {
          this.switchTab('detail');
          this.switchOperation('detail.show');
          if (this.$route.query.id != null) {
            this.list.search.eq_id = this.$route.query.id;
            ReviewServer.reviewReport.get(this.$route.query.id).then((res) => {
              this.setCurrentDetailData(res.data.result);
            });
          }
        } else {
          if (this.$route.query.source === 'index')  {
            AthubCloudApi.fetchCurrentTaskIds(this.workflowBusiness).then(res => {
              if (res.length <= 0) {
                this.list.search.in_id = [-1];
              } else {
                this.list.search.in_id = res;
              }
            });
          }
        }
      },
      handleCurrentOrderChange(value) {
        if (value) {
          if (this.list.search.in_status == null || this.list.search.in_status.length !== 2 || this.list.search.in_status.indexOf('DRAFT') === -1 || this.list.search.in_status.indexOf('WAPPR') === -1) {
            this.list.search.in_status = ['DRAFT', 'WAPPR'];
          }
        } else {
          this.list.search.in_status = null;
        }
      },
      beforeLeave(tabName, oldTabName) {
        // console.log(`beforeLeave tab: ${oldTabName} -> ${tabName}, operation: ${this.operation}`);
        if (oldTabName === 'detail' && (this.operation === 'detail.add' || this.operation === 'detail.edit')) {
          return this.$confirm('您输入的数据未保存，确认离开吗？', '离开提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.switchDefaultOperation(tabName);
            this.detail.data = this.currentRowData; // 回退原来的值
            return Promise.resolve();
          }, () => {
            return Promise.reject();
          });
        } else if (oldTabName === 'report' && (this.operation === 'report.add' || this.operation === 'report.edit')) {
          return this.$confirm('您输入的数据未保存，确认离开吗？', '离开提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.switchDefaultOperation(tabName);
            this.$refs['report'].loadReviewReportDetail();
            return Promise.resolve();
          }, () => {
            return Promise.reject();
          });
        } else {
          this.switchDefaultOperation(tabName);
        }
        return Promise.resolve();
      },
      switchTab(tabName) {
        this.activeTabName = tabName;
      },
      switchOperation(operation) {
        this.operation = operation;
        switch (operation) {
          case 'list.query':
            this.query();
            break;
        }
      },
      switchDefaultOperation(tabName) {
        if (this.operation == null || this.operation.split('.')[0] !== tabName) {
          let operation = 'list';
          if (tabName === 'list') {
            operation = 'list';
          } else if (tabName === 'detail') {
            operation = 'detail.show';
            this.detail.data = this.currentRowData;
          } else if (tabName === 'report') {
            operation = 'report.show'
          }
          this.switchOperation(operation);
        }
      },
      setCurrentRowData(currentRowData) {
        this.currentRowData = currentRowData;
      },
      setDetailData(data) {
        this.detail.data = data;
      },
      setCurrentDetailData(data) {
        this.currentRowData = data;
        this.detail.data = data;
      },
      query() {
        this.$refs['list'].reQueryByPage();
        /*let pageSearch = {
          search: this.list.search
        };
        this.$refs['list'].$data.pageSearch = merge(true, {}, this.$refs['list'].$data.pageSearch, pageSearch);*/
      },
      toAdd() {
        this.switchTab('detail');
        this.switchOperation('detail.add');
        this.detail.data = {
          status: 'DRAFT',
          type: this.type,
        };
      },
      showDetail(data) {
        this.switchTab('detail');
        this.switchOperation('detail.show');
        if (data != null) {
          this.currentRowData = data;
        }
        this.detail.data = this.currentRowData;
      },
      toEdit() {
        this.switchTab('detail');
        this.switchOperation('detail.edit');
      },
      saveAdd() {
        this.$refs['detail'].saveAdd();
      },
      saveEdit() {
        this.$refs['detail'].saveEdit();
      },
      cancelEdit() {
        this.$refs['detail'].cancelEdit();
      },
      toEditReport() {
        this.switchTab('report');
        this.switchOperation('report.edit');
      },
      saveEditReport() {
        this.$refs['report'].saveEdit();
      },
      cancelEditReport() {
        this.$refs['report'].cancelEdit();
      },
      remove() {
        this.$refs['detail'].remove();
      },
      toExportReport() {
        /*window.open(addParamsToUrl(`${REVIEW_SERVER}/reviewReport/${this.detail.data.id}/pdf`, {
          appId: window.localStorage.getItem('appId'),
          token: window.localStorage.getItem('token')
        }));*/
        ReviewServer.reviewReport.downloadPdf(this.detail.data.id, '报告.pdf', {loading: true});
        /*if (this.detail.data['status'] !== 'CLOSE') {
          this.$message.error('请在完工后再导出报告！');
        } else {
          window.open(addParamsToUrl(`${REVIEW_SERVER}/reviewReport/${this.detail.data.id}/pdf`, {
            appId: window.localStorage.getItem('appId'),
            token: window.localStorage.getItem('token')
          }));
        }*/
      },
      afterRequestWorkflowFunc(a) {
        this.workflowDialogVisible = true;
        this.workflowRequestInfo = a;
      },
      afterAuditWorkflowFunc(businessInfo) {
        ReviewServer.reviewReport.workflowAudit(businessInfo).then((res) => {
          if (res.data.code === 200) {
            this.showDetail(res.data.result._data);
            this.$refs.workflowDialog.close();
            this.workflowDialogVisible = false;
            this.$message.success('工作流发送成功！');
          } else {
            this.$message.error(res.data.message);
          }
        }, (error) => {
          this.$message.error(error);
        });
      },
      workflowHistoryLoaded(histories) {
        this.isSentWorkflow = histories.length > 0;
      }
    },
    watch: {
      'operation': {
        immediate: true,
        handler() {
          switch (this.operation) {
            case 'list.query':
              this.query();
              break;
          }
        }
      },
      'list.search.in_status': {
        immediate: true,
        handler(value) {
          if (value != null && value.length === 2 && value.indexOf('DRAFT') !== -1 && value.indexOf('WAPPR') !== -1) {
            this.list.search.currentOrder = true;
          } else {
            this.list.search.currentOrder = false;
          }
        }
      }
    },
    created() {
      this.$on('switch-tab', (tabName) => {
        this.switchTab(tabName);
      });
      this.$on('switch-operation', (operation) => {
        this.switchOperation(operation);
      });
      this.$on('search-change', (search) => {
        this.list.search = search;
      });
    },
    mounted() {
      this.init();
    },
  }

</script>
